/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionToggleLeft: {
  name: 'temp-selection-toggle-left';
  data: string;
} = {
  name: 'temp-selection-toggle-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 5a7 7 0 0 0 0 14h6a7 7 0 1 0 0-14H9Zm-5 7a5 5 0 0 1 5-5h6a5 5 0 0 1 0 10H9a5 5 0 0 1-5-5Zm4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" fill="currentColor"/></svg>`,
};
